import{SET_COUPON_FIELD_VALUE}from"../constants";/**
 * Creates the dispatched SET_COUPON_FIELD_VALUE action object.
 * @param {string} value Value
 * @returns {Object} The dispatched action object.
 */var setCouponFieldValue=function setCouponFieldValue(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return{type:SET_COUPON_FIELD_VALUE,value:value};};export default setCouponFieldValue;